export default __webpack_public_path__ + "static/media/barbers-button-right.f2d1f81f.svg";